/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReportTab200ResponseBillsInnerPaymentsInner } from './GetReportTab200ResponseBillsInnerPaymentsInner';
import {
    GetReportTab200ResponseBillsInnerPaymentsInnerFromJSON,
    GetReportTab200ResponseBillsInnerPaymentsInnerFromJSONTyped,
    GetReportTab200ResponseBillsInnerPaymentsInnerToJSON,
    GetReportTab200ResponseBillsInnerPaymentsInnerToJSONTyped,
} from './GetReportTab200ResponseBillsInnerPaymentsInner';
import type { GetReportTab200ResponseProductsInnerAllOfDiscount } from './GetReportTab200ResponseProductsInnerAllOfDiscount';
import {
    GetReportTab200ResponseProductsInnerAllOfDiscountFromJSON,
    GetReportTab200ResponseProductsInnerAllOfDiscountFromJSONTyped,
    GetReportTab200ResponseProductsInnerAllOfDiscountToJSON,
    GetReportTab200ResponseProductsInnerAllOfDiscountToJSONTyped,
} from './GetReportTab200ResponseProductsInnerAllOfDiscount';

/**
 * 
 * @export
 * @interface GetReportTab200ResponseBillsInner
 */
export interface GetReportTab200ResponseBillsInner {
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseBillsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseBillsInner
     */
    number: string;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseBillsInner
     */
    total: number;
    /**
     * 
     * @type {GetReportTab200ResponseProductsInnerAllOfDiscount}
     * @memberof GetReportTab200ResponseBillsInner
     */
    discount?: GetReportTab200ResponseProductsInnerAllOfDiscount;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseBillsInner
     */
    customerCompanyName?: string;
    /**
     * 
     * @type {Array<GetReportTab200ResponseBillsInnerPaymentsInner>}
     * @memberof GetReportTab200ResponseBillsInner
     */
    payments: Array<GetReportTab200ResponseBillsInnerPaymentsInner>;
}

/**
 * Check if a given object implements the GetReportTab200ResponseBillsInner interface.
 */
export function instanceOfGetReportTab200ResponseBillsInner(value: object): value is GetReportTab200ResponseBillsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('payments' in value) || value['payments'] === undefined) return false;
    return true;
}

export function GetReportTab200ResponseBillsInnerFromJSON(json: any): GetReportTab200ResponseBillsInner {
    return GetReportTab200ResponseBillsInnerFromJSONTyped(json, false);
}

export function GetReportTab200ResponseBillsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseBillsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'total': json['total'],
        'discount': json['discount'] == null ? undefined : GetReportTab200ResponseProductsInnerAllOfDiscountFromJSON(json['discount']),
        'customerCompanyName': json['customerCompanyName'] == null ? undefined : json['customerCompanyName'],
        'payments': ((json['payments'] as Array<any>).map(GetReportTab200ResponseBillsInnerPaymentsInnerFromJSON)),
    };
}

export function GetReportTab200ResponseBillsInnerToJSON(json: any): GetReportTab200ResponseBillsInner {
    return GetReportTab200ResponseBillsInnerToJSONTyped(json, false);
}

export function GetReportTab200ResponseBillsInnerToJSONTyped(value?: GetReportTab200ResponseBillsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': value['number'],
        'total': value['total'],
        'discount': GetReportTab200ResponseProductsInnerAllOfDiscountToJSON(value['discount']),
        'customerCompanyName': value['customerCompanyName'],
        'payments': ((value['payments'] as Array<any>).map(GetReportTab200ResponseBillsInnerPaymentsInnerToJSON)),
    };
}

